import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { PatientGroup } from 'src/app/data/dietitian/domain/patient_group/patient_group';

import { PatientGroupSidebarFacade } from './patient-group-sidebar.facade';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'msd-patient-group-sidebar',
  templateUrl: './patient-group-sidebar.component.html',
  styleUrls: ['./patient-group-sidebar.component.scss'],
  providers: [PatientGroupSidebarFacade],
})
export class PatientGroupSidebarComponent implements OnInit {
  private _selection: string | undefined;
  @Input() set selection(value: string | undefined) {
    this._selection = value;
    this.loadPatientGroup().then();
  }
  @Output() onClose = new EventEmitter();
  @Output() onEdit = new EventEmitter<boolean>();
  patientGroup: PatientGroup | undefined;
  patientGroupEventsSub: Subscription;
  isLoading = true;
  error?: string;
  editing = false;

  constructor(private facade: PatientGroupSidebarFacade) {
    // do nothing
  }

  ngOnInit(): void {
    this.patientGroupEventsSub = this.facade.patientGroupEvents$.subscribe(
      (event) => {
        if (event.entity.id.toString() == this._selection) {
          this.loadPatientGroup().then();
        }
      },
    );
  }

  async loadPatientGroup() {
    this.isLoading = true;
    this.error = undefined;
    try {
      if (this._selection) {
        this.patientGroup = await this.facade.getPatientGroup(this._selection);
      } else {
        this.patientGroup = undefined;
      }
    } catch (error: unknown) {
      if (error instanceof Error) {
        this.error = error.message;
      }
    }
    this.isLoading = false;
  }

  edit(editing: boolean) {
    this.editing = editing;
    this.onEdit.emit(this.editing);
  }

  ngOnDestroy(): void {
    this.patientGroupEventsSub?.unsubscribe();
  }
}
